<template>
    <div class="col-12 gm-budget-refresh">
        <div class="card card-outline card-navy gm-budget-panel">
            <div class="card-header gm-budget-top">
                <h3 class="card-title">Lista de Presupuestos</h3>
                <div class="card-tools">
                    <button class="btn btn-outline-success btn-sm mr-2" @click="exportData()">
                        <i class="fa fa-file-excel"></i> Exportar
                    </button>
                    <router-link :to="`/budgets/form`" v-can="'add_budgets'" class="btn btn-sm btn-outline-info">
                        <i class="fa fa-plus"></i> Presupuesto
                    </router-link>
                </div>
            </div>
            <div class="card-body gm-budget-body">
                <div class="row">
                    <div class="col-md-10">
                        <label>Buscar :</label>
                        <input class="form-control" v-debounce:1s="list" v-model="name">
                    </div>
                    <div class="col-md-2">
                        <label>ID :</label>
                        <input class="form-control" v-debounce:1s="list" v-model="id">
                    </div>
                    <div class="col-md-6">
                        <label>Propiedades :</label>
                        <select type="text" class="form-control" v-model="search.building_id">
                            <option value="">Todos</option>
                            <option v-for="(building, index) in catalogue.buildings" :value="building.id" :key="index">
                                {{ building.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <label>Empresa :</label>
                        <select v-model="search.company_id" class="form-control">
                            <option value="">Todos</option>
                            <option v-for="(company, index) in catalogue.companies_buildings" :key="index"
                                :value="company.id"> {{ company.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-6" v-if="authUser.organization_charts_id != 2">
                        <label>Usuario :</label>
                        <select type="text" class="form-control" v-model="search.user_id">
                            <option value="">Todos</option>
                            <option v-for="(user, index) in catalogue.users_profile" :value="user.id" :key="index">
                                {{ user.name }} {{ user.last_name }}</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <label>Categoría :</label>
                        <select type="text" class="form-control" v-model="search.concept_id">
                            <option value="">Todos</option>
                            <option v-for="(concept, index) in catalogue.concepts" :value="concept.id" :key="index">
                                {{ concept.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <label>Tipo :</label>
                        <select type="text" class="form-control" v-model="search.open">
                            <option value="">Todos</option>
                            <option value="0">Cerrados</option>
                            <option value="1">Abiertos</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                    </div>
                    <div class="col-md-6">
                        <button class="btn mt-4 btn-block btn-outline-secondary"
                            :class="search.requires_contract ? 'active' : ''"
                            @click="search.requires_contract = search.requires_contract ? '' : 1">
                            <i class="fa-solid fa-triangle-exclamation text-warning fa-fade"></i> - Requiere Contrato
                        </button>
                    </div>
                    <div class="col-md-6">
                        <button class="btn mt-4 btn-block btn-outline-secondary"
                            :class="search.no_repse_required ? 'active' : ''"
                            @click="search.no_repse_required = search.no_repse_required ? '' : 1">
                            <i class="fa-solid fa-triangle-exclamation text-primary fa-fade"></i> - Requiere REPSE
                        </button>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-md-12">
                        <ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" @click="search.status = 1" data-toggle="pill" role="tab"
                                    aria-selected="true">Activos</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" @click="search.status = 2" data-toggle="pill" role="tab"
                                    aria-selected="false">Terminados</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" @click="search.status = 3" data-toggle="pill" role="tab"
                                    aria-selected="false">Todos</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="table-responsive gm-budget-table-wrap">
                    <table class="table table-bordered text-center text-sm gm-budget-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th style="width: 40%;">Datos del presupuesto</th>
                                <th style="width: 140px;">Monto</th>
                                <th style="width: 140px;">Pagado</th>
                                <th style="width: 140px;">Resta</th>
                                <th>Opciones</th>
                            </tr>
                        </thead>
                        <tbody v-if="load">
                            <tr>
                                <td align="center" colspan="6">
                                    <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                    <h5>Cargando</h5>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="budgets.total > 0">
                            <tr v-for="(budget, index) in budgets.data" :key="index">
                                <td>
                                    {{ budget.id }}
                                    <br>
                                    <i v-if="budget.require_contract != 1 && !budget.contract"
                                        class="fa-solid fa-triangle-exclamation text-warning fa-fade m-1">
                                    </i>
                                    <i v-if="budget.no_repse_required != 1 && !budget.repse"
                                        class="fa-solid fa-triangle-exclamation text-primary fa-fade m-1">
                                    </i>
                                    <i v-if="budget.open == 1" class="fa-solid fa-lock text-info fa-fade m-1">
                                    </i>
                                    <br>
                                    <h6><span v-if="budget.status == 1 && search.status == 3"
                                            class="badge bg-success">Activo</span></h6>
                                    <h6><span v-if="budget.status == 2 && search.status == 3"
                                            class="badge bg-danger">Terminado</span></h6>
                                </td>
                                <td class="text-left">
                                    <!-- Propiedad -->
                                    <strong>Propiedad:</strong>
                                    <span v-if="budget.building"> {{ budget.building.name }}</span>
                                    <span v-else>N/A</span>
                                    <br>
                                    <!-- Indiviso -->
                                    <!-- Empresa -->
                                    <strong>Empresa:</strong>
                                    <span v-if="budget.company"> {{ budget.company.name }} </span>
                                    <span v-else>N/A</span>
                                    <br>
                                    <!-- Proveedor -->
                                    <strong>Usuario:</strong>
                                    <span v-if="budget.user"> {{ budget.user.name }} {{ budget.user.last_name }}</span>
                                    <span v-else>Sin usuario</span>
                                    <br>
                                    <!-- Moneda -->
                                    <strong>Moneda : </strong>
                                    <span v-if="budget.currency"> {{ budget.currency.name }}</span>
                                    <span v-else>MXN</span>
                                    <br>
                                    <span v-if="budget.currency_id == 2">
                                        <strong>Tipo de Cambio : </strong>
                                        <span> {{ budget.exchange_rate | toCurrency }}</span>
                                        <br>
                                    </span>
                                    <!-- Requiere contrato -->
                                    <strong>Requiere Contrato:</strong>
                                    <span v-if="budget.require_contract == 1"> No</span>
                                    <span v-else>Si</span>
                                    <br>
                                    <!-- Descripción -->
                                    <strong>Descripción:</strong><br>
                                    <span v-if="budget.description"> {{ budget.description }}</span>
                                    <span v-else>Sin descripción</span>
                                    <br>
                                    <!-- No servicio -->
                                    <div v-if="budget.no_service">
                                        <strong>No servicio: </strong><br>
                                        <span>{{ budget.no_service }}</span>
                                        <br>
                                    </div>
                                    <div>
                                        <strong>Autorizado por: </strong><br>
                                        <div class="badge p-1 badge-success ml-1"
                                            v-show="budget.users_approved.length > 0"
                                            v-for="(validator, index) in budget.users_approved" :key="index">
                                            <span>{{ validator.user.name }} {{ validator.user.last_name }}</span>
                                        </div>
                                        <div v-show="budget.users_approved.length == 0">
                                            <span>Ninguno</span>
                                        </div>
                                    </div>
                                    <br>
                                    <button @click="showBudget(budget.id)" type="button"
                                        class="btn btn-sm  m-1 btn-outline-secondary ">
                                        <i class="fa-solid fa-eye"></i> Ver
                                    </button>
                                    <button @click="downloadPDF(budget.id)" type="button"
                                        class="btn btn-sm  m-1 btn-outline-info ">
                                        <i class="fa-solid fa-eye"></i> Descargar PDF
                                    </button>
                                    <router-link :to="`/budgets/form/${budget.id}`" v-can="'edit_budgets'"
                                        class="btn btn-outline-primary m-1 btn-sm">
                                        <i class="fas fa-edit "> </i> Editar
                                    </router-link>
                                    <button type="button" @click="deleted(budget.id)" v-can="'deleted_budgets'"
                                        v-if="search.status != 3" class="btn-outline-danger btn m-1 btn-sm ">
                                        <i class="fa fa-trash"></i> Eliminar
                                    </button>
                                </td>
                                <td class="text-right" v-if="budget.currency_id >= 2">
                                    {{ (budget.open ? paysCheks(budget.checks, budget.currency_id) + budget.prepaid *
                                        budget.exchange_rate : budget.amount) * budget.exchange_rate | toCurrency }}
                                    <br>
                                    {{ (budget.open ? paysCheks(budget.checks) + budget.prepaid : budget.amount) |
                                        toCurrency }} {{ budget.currency.name }}
                                </td>
                                <td class="text-right" v-else>
                                    {{ (budget.open ? paysCheks(budget.checks) + budget.prepaid : budget.amount) |
                                        toCurrency }}
                                </td>
                                <td class="text-right" v-if="budget.currency_id >= 2">
                                    {{ paysCheks(budget.checks, budget.currency_id) + budget.prepaid *
                                        budget.exchange_rate | toCurrency }}
                                    <br>
                                    {{ paysCheks(budget.checks) + budget.prepaid | toCurrency }} {{ budget.currency.name
                                    }}
                                </td>
                                <td class="text-right" v-else>
                                    {{ paysCheks(budget.checks) + budget.prepaid | toCurrency }}
                                </td>
                                <td class="text-right" v-if="budget.currency_id >= 2">
                                    {{ (budget.open ? 0 : budget.amount - (paysCheks(budget.checks) + budget.prepaid)) *
                                        budget.exchange_rate | toCurrency }}
                                    <br>
                                    {{ (budget.open ? 0 : budget.amount - (paysCheks(budget.checks) + budget.prepaid)) |
                                        toCurrency }} {{ budget.currency.name }}
                                </td>
                                <td class="text-right" v-else>
                                    {{ budget.open ? 0 : budget.amount - (paysCheks(budget.checks) + budget.prepaid) |
                                        toCurrency }}
                                </td>
                                <td>
                                    <button type="button" @click="approve(budget.id)"
                                        v-if="shouldShowAuthorizeButton(budget) && search.status != 3"
                                        class="btn-outline-warning btn m-1 btn-sm ">
                                        <i class="fa fa-check"></i> Autorizar
                                    </button>
                                    <button type="button" v-if="budget.checks.length > 0"
                                        @click="showCheck(budget.checks)"
                                        class="btn m-1 btn-outline-secondary btn btn-sm ">
                                        <i class="fa-solid fa-hand-holding-dollar"></i> Pagos
                                    </button>
                                    <button type="button" @click="approveJuridical(budget.id)"
                                        v-if="authUser.organization_charts_id == 11 && !budget.juridical_user"
                                        class="btn-outline-warning btn m-1 btn-sm ">
                                        <i class="fa-solid fa-check-to-slot"></i> Aprobar jurídico
                                    </button>
                                    <button type="button" @click="changeStatus(budget)" v-can="'activate_budgets'"
                                        v-if="search.status != 3"
                                        :class="budget.status == 1 ? 'btn-outline-danger' : 'btn-outline-success'"
                                        class=" btn m-1 btn-sm ">
                                        <span v-if="budget.status == 1">
                                            <i class="fa-solid fa-power-off"></i> Terminar
                                        </span>
                                        <span v-else>
                                            <i class="fa-solid fa-power-off"></i> Activar
                                        </span>
                                    </button>
                                    <hr>
                                    <!-- Contratos -->
                                    <div class="gm-contract-list"
                                        v-if="budget.applies_to_service || budget.applies_to_work">
                                        <div v-if="shouldShowContract(budget, 1)" class="gm-contract-item">
                                            <div class="gm-contract-item__head">
                                                <span class="gm-contract-item__icon"><i
                                                        class="fa-solid fa-file-contract"></i></span>
                                                <div class="gm-contract-item__name"><strong>Contrato de
                                                        servicio</strong><small>Documento contractual</small></div>
                                                <span :class="contractBadgeClass(getContract(budget, 1))">{{
                                                    contractStatusLabel(getContract(budget, 1)) }}</span>
                                            </div>
                                            <div v-if="getContract(budget, 1) && isContractSigned(getContract(budget, 1))"
                                                class="gm-contract-item__signed">
                                                <i class="fa-solid fa-circle-check mr-1"></i>
                                                Firmado por {{ signerForContract(getContract(budget, 1)) || 'el proveedor' }}
                                                <small v-if="signedDateForContract(getContract(budget, 1))">{{
                                                    formatContractDate(signedDateForContract(getContract(budget, 1)))
                                                }}</small>
                                            </div>
                                            <div v-if="hasUploadedContract(getContract(budget, 1))"
                                                class="gm-contract-item__received">
                                                <div class="gm-contract-item__received-icon"><i
                                                        class="fa-solid fa-file-circle-check"></i></div>
                                                <div class="gm-contract-item__received-body">
                                                    <strong>PDF firmado recibido</strong>
                                                    <span
                                                        :title="uploadedContractFile(getContract(budget, 1)).original_name">{{
                                                            uploadedContractFile(getContract(budget, 1)).original_name
                                                        }}</span>
                                                    <small>Enviado por el proveedor · {{
                                                        formatContractDate(uploadedContractFile(getContract(budget,
                                                            1)).received_at) }}</small>
                                                </div>
                                                <!-- <span class="gm-contract-item__review-label">En revisión</span> -->
                                            </div>
                                            <div class="gm-contract-item__actions">
                                                <a target="_blank" rel="noopener noreferrer"
                                                    :href="`${globalUrlFiles}/contract-service/pdf/budget/${budget.id}`"
                                                    class="btn btn-outline-secondary btn-sm"><i
                                                        class="fa-regular fa-file-pdf mr-1"></i> Vista previa</a>
                                                <button
                                                    v-if="getContract(budget, 1) && isContractSigned(getContract(budget, 1))"
                                                    type="button" class="btn btn-success btn-sm"
                                                    @click="viewSignedContract(getContract(budget, 1))"><i
                                                        class="fa-solid fa-file-circle-check mr-1"></i> Ver PDF
                                                    firmado</button>
                                                <button v-if="canGenerateContractLink(getContract(budget, 1))"
                                                    type="button" class="btn btn-outline-primary btn-sm"
                                                    @click="generateContractLink(budget, 1, 1)"><i
                                                        class="fa-solid fa-link mr-1"></i> {{ getContract(budget, 1) ?
                                                            'Nuevo enlace' : 'Generar enlace' }}</button>

                                                <!-- Enviar enlace por correo -->
                                                <contract-email-button v-if="
                                                    getContract(budget, 1) &&
                                                    hasActiveLink(getContract(budget, 1)) &&
                                                    !isContractSigned(getContract(budget, 1)) &&
                                                    getContract(budget, 1).latest_request &&
                                                    getContract(budget, 1).latest_request.signature_url
                                                " :contract="getContract(budget, 1)" :source-type="1"
                                                    :contract-type="1"
                                                    :provider-email="budget.user ? budget.user.email : ''"
                                                    @sent="list(page)" />


                                                <button
                                                    v-if="getContract(budget, 1) && hasActiveLink(getContract(budget, 1)) && !isContractSigned(getContract(budget, 1)) && getContract(budget, 1).latest_request.signature_url"
                                                    type="button" class="btn btn-outline-info btn-sm"
                                                    @click="viewContractLink(getContract(budget, 1))"><i
                                                        class="fa-solid fa-eye mr-1"></i> Ver enlace</button>
                                                <button v-if="hasUploadedContract(getContract(budget, 1))" type="button"
                                                    class="btn btn-outline-success btn-sm"
                                                    @click="viewUploadedContract(getContract(budget, 1))">
                                                    <i class="fa-solid fa-file-pdf mr-1"></i> Ver PDF recibido
                                                </button>
                                                <button v-if="canCancelContractReceipt(getContract(budget, 1))"
                                                    type="button" class="btn btn-sm gm-contract-cancel"
                                                    :disabled="cancellingContractId === getContract(budget, 1).id"
                                                    @click="cancelReceivedContract(getContract(budget, 1))">
                                                    <i class="fa-solid fa-ban mr-1"></i>
                                                    {{ hasUploadedContract(getContract(budget, 1)) ? 'Cancelar archivo'
                                                        : 'Cancelar firma' }}
                                                </button>
                                            </div>
                                        </div>
                                        <div v-if="shouldShowContract(budget, 2)" class="gm-contract-item">
                                            <div class="gm-contract-item__head">
                                                <span class="gm-contract-item__icon"><i
                                                        class="fa-solid fa-file-signature"></i></span>
                                                <div class="gm-contract-item__name"><strong>Contrato de
                                                        obra</strong><small>Documento contractual</small></div>
                                                <span :class="contractBadgeClass(getContract(budget, 2))">{{
                                                    contractStatusLabel(getContract(budget, 2)) }}</span>
                                            </div>
                                            <div v-if="getContract(budget, 2) && isContractSigned(getContract(budget, 2))"
                                                class="gm-contract-item__signed">
                                                <i class="fa-solid fa-circle-check mr-1"></i>
                                                Firmado por {{ signerForContract(getContract(budget, 2)) || 'el proveedor' }}
                                                <small v-if="signedDateForContract(getContract(budget, 2))">{{
                                                    formatContractDate(signedDateForContract(getContract(budget, 2)))
                                                }}</small>
                                            </div>
                                            <div v-if="hasUploadedContract(getContract(budget, 2))"
                                                class="gm-contract-item__received">
                                                <div class="gm-contract-item__received-icon"><i
                                                        class="fa-solid fa-file-circle-check"></i></div>
                                                <div class="gm-contract-item__received-body">
                                                    <strong>PDF firmado recibido</strong>
                                                    <span
                                                        :title="uploadedContractFile(getContract(budget, 2)).original_name">{{
                                                            uploadedContractFile(getContract(budget, 2)).original_name
                                                        }}</span>
                                                    <small>Enviado por el proveedor · {{
                                                        formatContractDate(uploadedContractFile(getContract(budget,
                                                            2)).received_at) }}</small>
                                                </div>
                                                <!-- <span class="gm-contract-item__review-label">En revisión</span> -->
                                            </div>
                                            <div class="gm-contract-item__actions">
                                                <a target="_blank" rel="noopener noreferrer"
                                                    :href="`${globalUrlFiles}/contract-work/pdf/budget/${budget.id}`"
                                                    class="btn btn-outline-secondary btn-sm"><i
                                                        class="fa-regular fa-file-pdf mr-1"></i> Vista previa</a>
                                                <button
                                                    v-if="getContract(budget, 2) && isContractSigned(getContract(budget, 2))"
                                                    type="button" class="btn btn-success btn-sm"
                                                    @click="viewSignedContract(getContract(budget, 2))"><i
                                                        class="fa-solid fa-file-circle-check mr-1"></i> Ver PDF
                                                    firmado</button>
                                                <button v-if="canGenerateContractLink(getContract(budget, 2))"
                                                    type="button" class="btn btn-outline-primary btn-sm"
                                                    @click="generateContractLink(budget, 2, 1)"><i
                                                        class="fa-solid fa-link mr-1"></i> {{ getContract(budget, 2) ?
                                                            'Nuevo enlace' : 'Generar enlace' }}</button>

                                                <!-- Enviar enlace por correo -->
                                                <contract-email-button v-if="
                                                    getContract(budget, 2) &&
                                                    hasActiveLink(getContract(budget, 2)) &&
                                                    !isContractSigned(getContract(budget, 2)) &&
                                                    getContract(budget, 2).latest_request &&
                                                    getContract(budget, 2).latest_request.signature_url
                                                " :contract="getContract(budget, 2)" :source-type="1" :contract-type="2"
                                                    :provider-email="budget.user ? budget.user.email : ''"
                                                    @sent="list(page)" />


                                                <button
                                                    v-if="getContract(budget, 2) && hasActiveLink(getContract(budget, 2)) && !isContractSigned(getContract(budget, 2)) && getContract(budget, 2).latest_request.signature_url"
                                                    type="button" class="btn btn-outline-info btn-sm"
                                                    @click="viewContractLink(getContract(budget, 2))"><i
                                                        class="fa-solid fa-eye mr-1"></i> Ver enlace</button>
                                                <button v-if="hasUploadedContract(getContract(budget, 2))" type="button"
                                                    class="btn btn-outline-success btn-sm"
                                                    @click="viewUploadedContract(getContract(budget, 2))">
                                                    <i class="fa-solid fa-file-pdf mr-1"></i> Ver PDF recibido
                                                </button>
                                                <button v-if="canCancelContractReceipt(getContract(budget, 2))"
                                                    type="button" class="btn btn-sm gm-contract-cancel"
                                                    :disabled="cancellingContractId === getContract(budget, 2).id"
                                                    @click="cancelReceivedContract(getContract(budget, 2))">
                                                    <i class="fa-solid fa-ban mr-1"></i>
                                                    {{ hasUploadedContract(getContract(budget, 2)) ? 'Cancelar archivo'
                                                        : 'Cancelar firma' }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td align="center" colspan="6">Sin resultados.</td>
                            </tr>
                        </tbody>
                        <tfoot v-if="budgets.total > 0 && load == false">
                            <tr class="table-secondary">
                                <td colspan="2">
                                    Total :
                                </td>
                                <td class="text-right">
                                    {{ sumdata()[0] | toCurrency }}
                                </td>
                                <td class="text-right">
                                    {{ sumdata()[1] | toCurrency }}
                                </td>
                                <td class="text-right">
                                    {{ sumdata()[2] | toCurrency }}
                                </td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                    <pagination v-model="page" :records="budgets.total" :per-page="budgets.per_page" @paginate="list" />
                </div>
            </div>
        </div>
        <ModalTableComponent />
        <ModalFormComponentBudgets :prop_edit="false" />
    </div>
</template>
<script>
import ModalTableComponent from '@/components/checks/ModalTableComponent.vue';
import { mapMutations, mapActions, mapGetters } from 'vuex';
import Pagination from 'vue-pagination-2';
import request from '@/services/request';
import Catalogue from '@/services/catalogue';
import ModalFormComponentBudgets from '@/components/budgets/ModalTableComponent.vue';
import ContractEmailButton from '@/components/contracts/ContractEmailButton.vue';

export default {
    name: "companies-table",
    components: {
        ModalTableComponent,
        ModalFormComponentBudgets,
        Pagination,
        ContractEmailButton
    },
    data() {
        return {
            name: '',
            id: '',
            budgets: {},
            search: {
                status: 1,
                search: '',
                id: '',
                building_id: '',
                company_id: '',
                user_id: '',
                concept_id: '',
                requires_contract: '',
                no_repse_required: '',
                open: "",
            },
            page: 1,
            catalogue: new Catalogue(),
            load: false,
            cancellingContractId: null,
        }
    },
    mounted() {
        this.list();
        this.catalogue.get_buildings();
        this.catalogue.get_companies_buildings();
        this.catalogue.get_users_profile(2);
        this.catalogue.get_concepts();
        this.setHeaderTitle('Presupuestos');
    },
    created() {
        Event.$on("event-load-companies", () => {
            this.list();
        });
    },
    methods: {
        canCancelContractReceipt(contract) {
            if (!contract || !contract.id || !contract.latest_request) return false;
            if (Number(contract.latest_request.status) === 5) return false;
            return this.isContractSigned(contract) || this.hasUploadedContract(contract);
        },
        async cancelReceivedContract(contract) {
            if (!this.canCancelContractReceipt(contract)) return;
            const isSignature = this.isContractSigned(contract);
            const typeName = isSignature ? 'firma electrónica' : 'archivo PDF';
            const result = await this.$swal.fire({
                title: `Cancelar ${typeName}`,
                html: `<p class="text-muted mb-1">El documento recibido dejará de estar vigente y podrás generar un nuevo enlace para el proveedor. El historial se conservará.</p>`,
                icon: 'warning',
                input: 'textarea',
                inputLabel: 'Motivo de cancelación',
                inputPlaceholder: 'Escribe por qué se cancela esta recepción',
                inputAttributes: { maxlength: 500 },
                showCancelButton: true,
                confirmButtonText: 'Confirmar cancelación',
                cancelButtonText: 'Volver',
                confirmButtonColor: '#c0392b',
                reverseButtons: true,
                inputValidator: value => {
                    if (!value || value.trim().length < 5) {
                        return 'Escribe un motivo de al menos 5 caracteres.';
                    }
                }
            });
            if (!result.isConfirmed) return;
            try {
                await request.post(`/budget-buy-contracts/${contract.id}/cancel-received`, {
                    reason: result.value.trim()
                });
                await this.$swal.fire({
                    icon: 'success',
                    title: 'Recepción cancelada',
                    text: 'Ahora puedes generar un nuevo enlace de firma.',
                    confirmButtonText: 'Entendido'
                });
                await this.list(this.page);
            } catch (error) {
                await this.$swal.fire({
                    icon: 'error',
                    title: 'No fue posible cancelar',
                    text: (error.response && error.response.data && error.response.data.message) ||
                        'Verifica el contrato e inténtalo de nuevo.'
                });
            }
        },

        // Cada modalidad habilitada se muestra de forma independiente.
        shouldShowContract(budget, contractType) {
            if (!budget) return false;
            const enabled = Number(contractType) === 1
                ? budget.applies_to_service
                : budget.applies_to_work;
            return enabled === true || enabled === 1 || enabled === '1';
        },
        // El ID del contrato pertenece a budget_buy_contracts, no al presupuesto.
        viewSignedContract(contract) {
            if (!contract || !contract.id || !this.isContractSigned(contract)) return;
            const base = String(this.globalUrlFiles || '').replace(/\/$/, '');
            const url = `${base}/budget-buy-contracts/${encodeURIComponent(contract.id)}/signed-pdf`;
            window.open(url, '_blank', 'noopener,noreferrer');
        },
        uploadedContractFile(contract) {
            if (!contract) return null;
            return contract.uploaded_file || (contract.latest_request && contract.latest_request.uploaded_file) || null;
        },
        hasUploadedContract(contract) {
            return !!this.uploadedContractFile(contract);
        },
        viewUploadedContract(contract) {
            const file = this.uploadedContractFile(contract);
            if (!file || !file.id) return;
            // Esta URL requiere la ruta web autenticada descrita junto al archivo.
            const base = String(this.globalUrlFiles || '').replace(/\/$/, '');
            window.open(`${base}/budget-buy-contract-uploaded-files/${encodeURIComponent(file.id)}/pdf`, '_blank', 'noopener,noreferrer');
        },
        isContractSigned(contract) {
            if (!contract) return false;
            return contract.is_signed === true || contract.is_signed === 1 ||
                contract.is_signed === '1' ||
                !!(contract.latest_request && contract.latest_request.signature);
        },
        signerForContract(contract) {
            if (!contract) return '';
            const signature = contract.latest_request && contract.latest_request.signature;
            return contract.signer_name || (signature && signature.signer_name) || '';
        },
        signedDateForContract(contract) {
            if (!contract) return null;
            const signature = contract.latest_request && contract.latest_request.signature;
            return contract.signed_at || (signature && signature.signed_at) || null;
        },
        contractStatusLabel(contract) {
            if (!contract) return 'Sin enlace';
            if (this.isContractSigned(contract)) return 'Firmado electrónicamente';
            if (this.hasUploadedContract(contract)) return 'PDF recibido';
            switch (Number(contract.status)) {
                case 1: return this.hasActiveLink(contract) ? 'Pendiente de firma' : 'Sin enlace vigente';
                case 2: return 'Pendiente de validación';
                case 3: return 'Contrato firmado';
                case 4: return 'Cancelado';
                default: return 'Estado no disponible';
            }
        },
        contractBadgeClass(contract) {
            if (this.isContractSigned(contract)) return 'badge badge-success';
            if (this.hasUploadedContract(contract)) return 'badge badge-success';
            if (!contract) return 'badge badge-light border';
            const status = Number(contract.status);
            if (status === 3) return 'badge badge-success';
            if (status === 2) return 'badge badge-info';
            if (status === 4) return 'badge badge-secondary';
            return 'badge badge-warning';
        },
        canGenerateContractLink(contract) {
            if (!contract) return true;
            if (this.isContractSigned(contract) || this.hasUploadedContract(contract)) return false;
            return this.needsNewLink(contract);
        },
        formatContractDate(value) {
            if (!value) return '';
            const date = new Date(value);
            return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString('es-MX');
        },
        viewContractLink(contract) {
            if (
                !contract ||
                !contract.latest_request
            ) {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Enlace no disponible',
                    text: 'No se encontró un enlace activo para este contrato.'
                });
                return;
            }
            const signatureRequest =
                contract.latest_request;
            if (!signatureRequest.signature_url) {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Enlace no disponible',
                    text: 'El enlace expiró o ya no se encuentra disponible.'
                });
                return;
            }
            this.showContractLink(
                signatureRequest.signature_url,
                signatureRequest.expires_at_formatted
            );
        },
        // |--------------------------------------------------------------------------
        // | CONTRATOS
        // |--------------------------------------------------------------------------
        // Obtiene el contrato correspondiente.
        // contractType:
        // 1 = Servicio
        // 2 = Obra
        getContract(item, contractType) {
            if (!item || !Array.isArray(item.budget_buy_contracts)) return null;
            const matching = item.budget_buy_contracts.filter(contract =>
                Number(contract.contract_type) === Number(contractType)
            );
            // Cada tipo conserva su propio registro; nunca depende del otro.
            return matching.find(contract => this.isContractSigned(contract) || this.hasUploadedContract(contract) || Number(contract.status) === 3)
                || matching.find(contract => Number(contract.status) !== 4)
                || matching[0]
                || null;
        },
        // Estados 1 y 2 representan solicitudes de firma vigentes.
        hasActiveLink(contract) {
            if (this.isContractSigned(contract) || this.hasUploadedContract(contract)) return false;
            if (
                !contract ||
                !contract.latest_request
            ) {
                return false;
            }
            var signatureRequest =
                contract.latest_request;
            var status =
                Number(signatureRequest.status);
            return (
                (status === 1 || status === 2) &&
                signatureRequest.is_expired === false
            );
        },
        // Determina si debe generarse un enlace nuevo.
        needsNewLink(contract) {
            if (this.isContractSigned(contract) || this.hasUploadedContract(contract)) return false;
            if (!contract) {
                return true;
            }
            // El contrato debe seguir pendiente
            // de firma del proveedor.
            // 1 = Pendiente firma proveedor
            if (
                Number(contract.status) !== 1
            ) {
                return false;
            }
            // Nunca se ha generado enlace.
            if (!contract.latest_request) {
                return true;
            }
            var signatureRequest =
                contract.latest_request;
            var status =
                Number(signatureRequest.status);
            // 4 = Expirado
            // 5 = Cancelado
            return (
                signatureRequest.is_expired ||
                status === 4 ||
                status === 5
            );
        },
        // Generar enlace de firma.
        // sourceType:
        // 1 = Budget
        // 2 = Buy
        // contractType:
        // 1 = Servicio
        // 2 = Obra
        async generateContractLink(
            item,
            contractType,
            sourceType
        ) {
            if (this.isContractSigned(this.getContract(item, contractType))) {
                await this.$swal.fire({
                    icon: 'info',
                    title: 'Firma ya registrada',
                    text: 'Este contrato ya cuenta con una firma y no admite otro enlace.'
                });
                return;
            }
            const contractName =
                Number(contractType) === 1
                    ? 'servicio'
                    : 'obra';
            const confirmation =
                await this.$swal.fire({
                    title: 'Generar enlace de firma',
                    html: `
                        <div class="text-left">
                            <p class="mb-3">
                                Se generará un enlace único para el
                                <strong>contrato de ${contractName}</strong>.
                            </p>
                            <div
                                class="
                                    alert
                                    alert-warning
                                    mb-3
                                "
                            >
                                <i
                                    class="
                                        fa-solid
                                        fa-clock
                                        mr-1
                                    "
                                ></i>
                                El enlace tendrá una vigencia de
                                <strong>3 días</strong>.
                            </div>
                            <p class="text-muted mb-0">
                                Podrás copiar el enlace y compartirlo
                                con el proveedor por WhatsApp,
                                correo electrónico o cualquier otro medio.
                            </p>
                        </div>
                    `,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText:
                        '<i class="fa-solid fa-link mr-1"></i> Generar enlace',
                    cancelButtonText:
                        'Cancelar',
                    confirmButtonColor:
                        '#3085d6',
                    cancelButtonColor:
                        '#6c757d'
                });
            if (!confirmation.isConfirmed) {
                return;
            }
            try {
                const { data } =
                    await request.post(
                        '/budget-buy-contracts/generate-link',
                        {
                            budget_buy_id:
                                item.id,
                            source_type:
                                sourceType,
                            contract_type:
                                contractType
                        }
                    );
                if (
                    !data ||
                    !data.data ||
                    !data.data.signature_url
                ) {
                    throw new Error(
                        'La API no regresó el enlace de firma.'
                    );
                }
                let expiresAt = '';
                if (
                    data.data.request &&
                    data.data.request.expires_at_formatted
                ) {
                    expiresAt =
                        data.data.request.expires_at_formatted;
                } else if (
                    data.data.expires_at_formatted
                ) {
                    // Compatibilidad por si la respuesta
                    // todavía utiliza la estructura anterior.
                    expiresAt =
                        data.data.expires_at_formatted;
                }
                await this.showContractLink(
                    data.data.signature_url,
                    expiresAt
                );
                // Recargar listado para obtener:
                // budget_buy_contracts
                // latest_request
                // statuses
                await this.list(this.page);
            } catch (error) {
                console.error(error);
                let message =
                    'No fue posible generar el enlace de firma.';
                if (
                    error.response &&
                    error.response.data &&
                    error.response.data.message
                ) {
                    message =
                        error.response.data.message;
                } else if (
                    error.message
                ) {
                    message =
                        error.message;
                }
                this.$swal.fire({
                    icon: 'error',
                    title:
                        'No se pudo generar el enlace',
                    text:
                        message,
                    confirmButtonText:
                        'Aceptar'
                });
            }
        },
        // Mostrar enlace recién generado.
        // IMPORTANTE:
        // El token original no se almacena en BD,
        // por lo tanto éste es el momento para copiarlo.
        async showContractLink(signatureUrl, expiresAt) {
            const expirationHtml = expiresAt
                ? `
            <div class="gm-contract-expiration">
                <div class="gm-contract-expiration-icon">
                    <i class="fa-regular fa-clock"></i>
                </div>
                <div>
                    <span>Vigencia del enlace</span>
                    <strong>${expiresAt}</strong>
                </div>
            </div>
        `
                : '';
            const result = await this.$swal.fire({
                width: 590,
                padding: 0,
                showCloseButton: true,
                title: '',
                html: `
            <div class="gm-contract-modal">
                <!-- HEADER -->
                <div class="gm-contract-header">
                    <div class="gm-contract-header-icon">
                        <i class="fa-solid fa-link"></i>
                    </div>
                    <div class="gm-contract-header-info">
                        <h3>
                            Enlace de firma
                        </h3>
                        <p>
                            Comparte este acceso con el proveedor
                            responsable del contrato.
                        </p>
                    </div>
                </div>
                <!-- BODY -->
                <div class="gm-contract-body">
                    <!-- ESTADO -->
                    <div class="gm-contract-status">
                        <div class="gm-contract-status-icon">
                            <i class="fa-solid fa-check"></i>
                        </div>
                        <div>
                            <strong>
                                Enlace activo
                            </strong>
                            <span>
                                El acceso está listo para compartirse.
                            </span>
                        </div>
                    </div>
                    <!-- LINK -->
                    <div class="gm-contract-field">
                        <label>
                            Enlace para firma
                        </label>
                        <div class="gm-contract-input-container">
                            <i class="fa-solid fa-link"></i>
                            <input
                                id="contract-signature-url"
                                type="text"
                                readonly
                            >
                        </div>
                        <small>
                            El proveedor podrá abrir el contrato,
                            revisarlo y continuar con el proceso de firma.
                        </small>
                    </div>
                    <!-- VIGENCIA -->
                    ${expirationHtml}
                    <!-- COMPARTIR -->
                    <div class="gm-contract-info">
                        <div class="gm-contract-info-icon">
                            <i class="fa-solid fa-share-nodes"></i>
                        </div>
                        <div>
                            <strong>
                                Compartir enlace
                            </strong>
                            <span>
                                Puedes enviarlo por WhatsApp, correo
                                electrónico o cualquier otro medio autorizado.
                            </span>
                        </div>
                    </div>
                    <!-- SEGURIDAD -->
                    <div class="gm-contract-security">
                        <i class="fa-solid fa-shield-halved"></i>
                        <span>
                            Enlace único para este proceso contractual.
                            Evita compartirlo con personas ajenas.
                        </span>
                    </div>
                </div>
            </div>
        `,
                showCancelButton: true,
                showDenyButton: true,
                buttonsStyling: false,
                confirmButtonText: `
            <i class="fa-solid fa-copy mr-1"></i>
            Copiar enlace
        `,
                denyButtonText: `
            <i class="fa-solid fa-arrow-up-right-from-square mr-1"></i>
            Abrir enlace
        `,
                cancelButtonText: 'Cerrar',
                focusConfirm: false,
                customClass: {
                    popup: 'gm-contract-popup',
                    htmlContainer: 'gm-contract-html',
                    actions: 'gm-contract-actions',
                    confirmButton: 'gm-contract-btn gm-contract-btn-primary',
                    denyButton: 'gm-contract-btn gm-contract-btn-outline-info',
                    cancelButton: 'gm-contract-btn gm-contract-btn-outline',
                    closeButton: 'gm-contract-close'
                },
                didOpen: () => {
                    const input =
                        document.getElementById(
                            'contract-signature-url'
                        );
                    if (input) {
                        input.value = signatureUrl;
                        input.addEventListener(
                            'click',
                            function () {
                                this.select();
                            }
                        );
                    }
                },
                preConfirm: async () => {
                    const copied =
                        await this.copyContractLink(
                            signatureUrl
                        );
                    if (!copied) {
                        return false;
                    }
                    return true;
                }
            });
            if (result.isDenied) {
                window.open(
                    signatureUrl,
                    '_blank',
                    'noopener,noreferrer'
                );
                return;
            }
            if (result.isConfirmed) {
                this.$swal.fire({
                    icon: 'success',
                    title: 'Enlace copiado',
                    text:
                        'Ya puedes compartirlo con el proveedor.',
                    timer: 1400,
                    showConfirmButton: false
                });
            }
        },
        // Copiar URL al portapapeles.
        // navigator.clipboard requiere HTTPS.
        // document.execCommand funciona como fallback.
        async copyContractLink(url) {
            try {
                if (
                    navigator.clipboard &&
                    window.isSecureContext
                ) {
                    await navigator.clipboard.writeText(
                        url
                    );
                    return true;
                }
                const textarea =
                    document.createElement(
                        'textarea'
                    );
                textarea.value =
                    url;
                textarea.style.position =
                    'fixed';
                textarea.style.left =
                    '-999999px';
                textarea.style.top =
                    '-999999px';
                document.body.appendChild(
                    textarea
                );
                textarea.focus();
                textarea.select();
                const copied =
                    document.execCommand(
                        'copy'
                    );
                document.body.removeChild(
                    textarea
                );
                if (!copied) {
                    throw new Error(
                        'No fue posible copiar el enlace.'
                    );
                }
                return true;
            } catch (error) {
                console.error(error);
                this.$swal.showValidationMessage(
                    'No fue posible copiar automáticamente. Selecciona y copia el enlace manualmente.'
                );
                return false;
            }
        },
        // |--------------------------------------------------------------------------
        // | PDF PRESUPUESTO
        // |--------------------------------------------------------------------------
        downloadPDF(id) {
            let filter =
                this.globalUrlFiles +
                '/budgets/' +
                id +
                '/pdf';
            window.open(
                filter,
                '_blank'
            );
        },
        // |--------------------------------------------------------------------------
        // | AUTORIZACIONES
        // |--------------------------------------------------------------------------
        shouldShowAuthorizeButton(contract) {
            const userId =
                this.authUser.id;
            const validator =
                contract.users_approved.find(
                    v =>
                        v.user_id === userId
                );
            return !validator;
        },
        // |--------------------------------------------------------------------------
        // | TOTALES
        // |--------------------------------------------------------------------------
        sumdata() {
            let vm = this;
            let sum1 = 0;
            let sum2 = 0;
            let sum3 = 0;
            if (
                this.budgets &&
                Array.isArray(
                    this.budgets.data
                )
            ) {
                this.budgets.data.forEach(
                    function (budget) {
                        sum1 +=
                            budget.open
                                ? vm.paysCheks(
                                    budget.checks,
                                    2
                                ) +
                                budget.prepaid *
                                (
                                    budget.currency_id == 2
                                        ? budget.exchange_rate
                                        : 1
                                )
                                : parseFloat(
                                    budget.amount
                                ) *
                                (
                                    budget.currency_id == 2
                                        ? budget.exchange_rate
                                        : 1
                                );
                        sum2 +=
                            vm.paysCheks(
                                budget.checks,
                                2
                            ) +
                            budget.prepaid *
                            (
                                budget.currency_id == 2
                                    ? budget.exchange_rate
                                    : 1
                            );
                        sum3 +=
                            budget.open
                                ? 0
                                : (
                                    parseFloat(
                                        budget.amount
                                    ) -
                                    (
                                        vm.paysCheks(
                                            budget.checks
                                        ) +
                                        budget.prepaid
                                    )
                                ) *
                                (
                                    budget.currency_id == 2
                                        ? budget.exchange_rate
                                        : 1
                                );
                    }
                );
            }
            return [
                sum1,
                sum2,
                sum3
            ];
        },
        // |--------------------------------------------------------------------------
        // | VER PRESUPUESTO
        // |--------------------------------------------------------------------------
        showBudget(id) {
            Event.$emit(
                'event-load-budget',
                id
            );
        },
        // |--------------------------------------------------------------------------
        // | EXPORTAR
        // |--------------------------------------------------------------------------
        exportData() {
            let filter =
                this.globalUrlFiles +
                '/budgets/export?' +
                new URLSearchParams(
                    this.search
                ).toString();
            filter +=
                '&user_login=' +
                this.authUser.id;
            window.open(
                filter,
                '_blank'
            );
        },
        // |--------------------------------------------------------------------------
        // | PAGOS
        // |--------------------------------------------------------------------------
        showCheck(checks) {
            Event.$emit(
                'event-show-listChecks',
                checks
            );
        },
        // |--------------------------------------------------------------------------
        // | CAMBIAR ESTATUS
        // |--------------------------------------------------------------------------
        changeStatus: function (budget) {
            let tit =
                budget.status == 1
                    ? 'Termina presupuesto'
                    : 'Activar presupuesto';
            let txt =
                budget.status == 1
                    ? 'Seguro que quiere terminar el presupuesto'
                    : 'Seguro que quiere activar el presupuesto';
            this.$swal({
                title:
                    tit,
                text:
                    txt,
                icon:
                    'warning',
                showCancelButton:
                    true,
                confirmButtonColor:
                    '#3085d6',
                cancelButtonColor:
                    '#d33',
                confirmButtonText:
                    'Ok',
                cancelButtonText:
                    'Cancelar'
            }).then(async (result) => {
                if (
                    result.isConfirmed
                ) {
                    let _endpoint =
                        '/budgets_status?id=' +
                        budget.id;
                    try {
                        let response =
                            await request.post(
                                _endpoint
                            );
                        this.list();
                        this.successNotification(
                            response.data.message
                        );
                    } catch (error) {
                        this.errors =
                            await this.errorNotification(
                                error
                            );
                    }
                }
            });
        },
        // |--------------------------------------------------------------------------
        // | SUMA DE PAGOS
        // |--------------------------------------------------------------------------
        paysCheks(
            checks,
            currency = 1
        ) {
            let sum = 0;
            if (
                !Array.isArray(checks)
            ) {
                return sum;
            }
            checks.forEach((check) => {
                if (
                    Array.isArray(check.pay) &&
                    check.pay.length > 0
                ) {
                    check.pay.forEach(
                        (pay) => {
                            if (pay.amount) {
                                sum +=
                                    parseFloat(
                                        pay.amount
                                    ) *
                                    (
                                        currency == 2 &&
                                            check.currency_id == 2
                                            ? check.exchange
                                            : 1
                                    );
                            }
                        }
                    );
                }
            });
            return sum;
        },
        // |--------------------------------------------------------------------------
        // | ELIMINAR
        // |--------------------------------------------------------------------------
        deleted: function (id) {
            let tit =
                'Eliminar Presupuestos';
            let txt =
                'Seguro que quiere eliminar el presupuesto';
            this.$swal({
                title:
                    tit,
                text:
                    txt,
                icon:
                    'warning',
                showCancelButton:
                    true,
                confirmButtonColor:
                    '#3085d6',
                cancelButtonColor:
                    '#d33',
                confirmButtonText:
                    'Ok',
                cancelButtonText:
                    'Cancelar'
            }).then((result) => {
                if (
                    result.isConfirmed
                ) {
                    this.callDeleted(
                        id
                    );
                }
            });
        },
        // |--------------------------------------------------------------------------
        // | APROBAR
        // |--------------------------------------------------------------------------
        approve: function (id) {
            let tit =
                'Aprobar Presupuestos';
            let txt =
                'Seguro que quiere aprobar el presupuesto';
            this.$swal({
                title:
                    tit,
                text:
                    txt,
                icon:
                    'warning',
                showCancelButton:
                    true,
                confirmButtonColor:
                    '#3085d6',
                cancelButtonColor:
                    '#d33',
                confirmButtonText:
                    'Ok',
                cancelButtonText:
                    'Cancelar'
            }).then(async (result) => {
                if (
                    result.isConfirmed
                ) {
                    let _endpoint =
                        '/budget_validators';
                    let form = {
                        id: id
                    };
                    try {
                        let response =
                            await request.post(
                                _endpoint,
                                form
                            );
                        this.list();
                        this.successNotification(
                            response.data.message
                        );
                    } catch (error) {
                        this.errors =
                            await this.errorNotification(
                                error
                            );
                    }
                }
            });
        },
        // |--------------------------------------------------------------------------
        // | APROBAR JURÍDICO
        // |--------------------------------------------------------------------------
        approveJuridical: function (id) {
            let tit =
                'Aprobar Presupuestos';
            let txt =
                'Seguro que quiere aprobar el presupuesto';
            this.$swal({
                title:
                    tit,
                text:
                    txt,
                icon:
                    'warning',
                showCancelButton:
                    true,
                confirmButtonColor:
                    '#3085d6',
                cancelButtonColor:
                    '#d33',
                confirmButtonText:
                    'Ok',
                cancelButtonText:
                    'Cancelar'
            }).then(async (result) => {
                if (
                    result.isConfirmed
                ) {
                    let _endpoint =
                        '/budgets_approve_juridical';
                    let form = {
                        id: id
                    };
                    try {
                        let response =
                            await request.post(
                                _endpoint,
                                form
                            );
                        this.list();
                        this.successNotification(
                            response.data.message
                        );
                    } catch (error) {
                        this.errors =
                            await this.errorNotification(
                                error
                            );
                    }
                }
            });
        },
        // |--------------------------------------------------------------------------
        // | DELETE API
        // |--------------------------------------------------------------------------
        async callDeleted(id) {
            let _endpoint =
                '/budgets/' +
                id;
            try {
                let response =
                    await request.destroy(
                        _endpoint
                    );
                this.list();
                this.successNotification(
                    response.data.message
                );
            } catch (error) {
                this.errors =
                    await this.errorNotification(
                        error
                    );
            }
        },
        showImport() {
            this.$modal.show(
                'example'
            );
        },
        // |--------------------------------------------------------------------------
        // | LISTADO
        // |--------------------------------------------------------------------------
        async list(page = 1) {
            this.load = true;
            this.page = page;
            let search =
                this.search;
            search.search =
                this.name;
            search.id =
                this.id;
            let _endpoint =
                '/budgets';
            try {
                let { data } =
                    await request.list(
                        _endpoint,
                        page,
                        search
                    );
                if (data) {
                    this.budgets =
                        data;
                }
                this.load =
                    false;
            } catch (error) {
                console.error(error);
                this.load =
                    false;
            }
        },
        // |--------------------------------------------------------------------------
        // | VUEX
        // |--------------------------------------------------------------------------
        ...mapMutations({
            setHeaderTitle:
                'setHeaderTitle',
        }),
        ...mapActions({
            resetPassword:
                'auth/resetPass',
            errorNotification:
                'alert/error',
            successNotification:
                'alert/success',
        }),
    },
    // |--------------------------------------------------------------------------
    // | WATCH
    // |--------------------------------------------------------------------------
    watch: {
        'search': {
            handler: function () {
                this.page = 1;
                this.list();
            },
            deep: true
        }
    },
    // |--------------------------------------------------------------------------
    // | COMPUTED
    // |--------------------------------------------------------------------------
    computed: {
        ...mapGetters({
            'authUser':
                'auth/user'
        })
    },
}
</script>
<style>
.pagination {
    margin-bottom: 0;
}

.bg-success {
    background-color: #28a745 !important;
}

.bg-primary {
    background-color: #17a2b8 !important;
}

.gm-contract-popup {
    padding: 0 !important;
    overflow: hidden !important;
    border-radius: 8px !important;
    box-shadow:
        0 12px 35px rgba(0, 0, 0, .18) !important;
}

.gm-contract-html {
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
}

.gm-contract-header {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    background: #ffffff;
    border-bottom: 1px solid #e5e8eb;
}

.gm-contract-header-icon {
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 13px;
    border-radius: 6px;
    background: #001f3f;
    color: #ffffff;
    font-size: 16px;
}

.gm-contract-header-info {
    min-width: 0;
    text-align: left;
}

.gm-contract-header-info h3 {
    margin: 0 0 3px;
    color: #343a40;
    font-size: 18px;
    line-height: 1.2;
    font-weight: 600;
}

.gm-contract-header-info p {
    margin: 0;
    color: #6c757d;
    font-size: 12px;
    line-height: 1.4;
}

.gm-contract-body {
    padding: 22px 24px 18px;
    text-align: left;
    background: #ffffff;
}

.gm-contract-status {
    display: flex;
    align-items: center;
    padding: 12px 14px;
    margin-bottom: 20px;
    border: 1px solid #cce7d4;
    border-radius: 6px;
    background: #f1faf4;
}

.gm-contract-status-icon {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 11px;
    border-radius: 50%;
    background: #28a745;
    color: #ffffff;
    font-size: 12px;
}

.gm-contract-status strong {
    display: block;
    margin-bottom: 1px;
    color: #28753b;
    font-size: 13px;
    font-weight: 600;
}

.gm-contract-status span {
    display: block;
    color: #5c7462;
    font-size: 11px;
}

.gm-contract-field {
    margin-bottom: 18px;
}

.gm-contract-field label {
    display: block;
    margin-bottom: 6px;
    color: #343a40;
    font-size: 12px;
    font-weight: 600;
}

.gm-contract-input-container {
    position: relative;
    display: flex;
    align-items: center;
}

.gm-contract-input-container>i {
    position: absolute;
    left: 13px;
    color: #73808c;
    font-size: 12px;
    pointer-events: none;
}

.gm-contract-input-container input {
    width: 100%;
    height: 42px;
    padding: 0 12px 0 37px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #f8f9fa;
    color: #495057;
    font-size: 12px;
    outline: none;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.gm-contract-input-container input:focus {
    background: #ffffff;
    border-color: #80bdff;
    box-shadow:
        0 0 0 .15rem rgba(0, 123, 255, .12);
}

.gm-contract-field small {
    display: block;
    margin-top: 6px;
    color: #7b8791;
    font-size: 10.5px;
    line-height: 1.4;
}

.gm-contract-expiration {
    display: flex;
    align-items: center;
    padding: 11px 13px;
    margin-bottom: 14px;
    border: 1px solid #ffe29a;
    border-radius: 6px;
    background: #fff9e6;
}

.gm-contract-expiration-icon {
    width: 34px;
    height: 34px;
    flex: 0 0 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 11px;
    border-radius: 5px;
    background: #ffc107;
    color: #ffffff;
    font-size: 13px;
}

.gm-contract-expiration span {
    display: block;
    margin-bottom: 1px;
    color: #856404;
    font-size: 10.5px;
}

.gm-contract-expiration strong {
    display: block;
    color: #6b5200;
    font-size: 13px;
    font-weight: 600;
}

.gm-contract-info {
    display: flex;
    align-items: center;
    padding: 11px 13px;
    border: 1px solid #d6e6ed;
    border-radius: 6px;
    background: #f4fafc;
}

.gm-contract-info-icon {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 11px;
    color: #17a2b8;
    font-size: 14px;
}

.gm-contract-info strong {
    display: block;
    margin-bottom: 2px;
    color: #3d5964;
    font-size: 12px;
}

.gm-contract-info span {
    display: block;
    color: #71858d;
    font-size: 10.5px;
    line-height: 1.4;
}

.gm-contract-security {
    display: flex;
    align-items: center;
    margin-top: 15px;
    padding-top: 13px;
    border-top: 1px solid #edf0f2;
    color: #6c757d;
    font-size: 10.5px;
    line-height: 1.4;
}

.gm-contract-security i {
    margin-right: 8px;
    color: #001f3f;
    font-size: 12px;
}

.gm-contract-actions {
    width: 100% !important;
    display: flex !important;
    justify-content: flex-end !important;
    gap: 7px;
    margin: 0 !important;
    padding: 14px 24px 17px !important;
    border-top: 1px solid #e5e8eb;
    background: #f8f9fa;
}

.gm-contract-btn {
    min-width: 105px;
    margin: 0 !important;
    padding: 8px 14px !important;
    border-radius: 4px !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    cursor: pointer;
}

.gm-contract-btn-primary {
    border: 1px solid #001f3f !important;
    background: #001f3f !important;
    color: #ffffff !important;
}

.gm-contract-btn-primary:hover {
    border-color: #00172f !important;
    background: #00172f !important;
}

.gm-contract-btn-outline-info {
    border: 1px solid #17a2b8 !important;
    background: #ffffff !important;
    color: #138496 !important;
}

.gm-contract-btn-outline-info:hover {
    background: #17a2b8 !important;
    color: #ffffff !important;
}

.gm-contract-btn-outline {
    border: 1px solid #adb5bd !important;
    background: #ffffff !important;
    color: #5f6972 !important;
}

.gm-contract-btn-outline:hover {
    background: #e9ecef !important;
}

.gm-contract-close {
    top: 8px !important;
    right: 9px !important;
    width: 30px !important;
    height: 30px !important;
    color: #adb5bd !important;
    font-size: 22px !important;
    line-height: 30px !important;
}

.gm-contract-close:hover {
    color: #495057 !important;
}

@media (max-width: 576px) {
    .gm-contract-popup {
        width: calc(100% - 20px) !important;
    }

    .gm-contract-header {
        padding: 17px;
    }

    .gm-contract-body {
        padding: 18px 17px 15px;
    }

    .gm-contract-header-icon {
        width: 38px;
        height: 38px;
        flex-basis: 38px;
    }

    .gm-contract-header-info h3 {
        font-size: 16px;
    }

    .gm-contract-header-info p {
        padding-right: 15px;
        font-size: 11px;
    }

    .gm-contract-actions {
        flex-direction: column;
        padding: 13px 17px 16px !important;
    }

    .gm-contract-btn {
        width: 100%;
    }
}

.pagination {
    margin-bottom: 0;
}

/* Tarjetas de contratos: servicio y obra se muestran por separado. */
.gm-contract-list {
    display: grid;
    gap: 12px;
    margin-top: 14px;
    text-align: left;
}

.gm-contract-item {
    padding: 15px;
    border: 1px solid #dce5ee;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 31, 63, .035);
    transition: border-color .2s ease, box-shadow .2s ease;
}

.gm-contract-item:hover {
    border-color: #b4c6da;
    box-shadow: 0 5px 20px rgba(0, 31, 63, .07);
}

.gm-contract-item__head {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.gm-contract-item__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 38px;
    height: 38px;
    background: #edf3f9;
    color: #001f3f;
    border-radius: 9px;
}

.gm-contract-item__name {
    display: flex;
    flex: 1 1 130px;
    flex-direction: column;
    min-width: 0;
    line-height: 1.4;
}

.gm-contract-item__name strong {
    font-size: 13px;
    color: #24364a;
}

.gm-contract-item__name small {
    font-size: 11px;
    color: #718096;
}

.gm-contract-item__head>.badge {
    margin-left: auto;
    padding: 7px 10px;
    font-size: 10px;
    line-height: 1.35;
    white-space: normal;
}

.gm-contract-item__signed {
    margin-top: 12px;
    padding: 10px 12px;
    border: 1px solid #d3eadb;
    border-radius: 8px;
    background: #effaf3;
    color: #22663b;
    font-size: 12px;
}

.gm-contract-item__signed small {
    display: block;
    margin-top: 3px;
    color: #47775a;
}

.gm-contract-item__actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
}

.gm-contract-item__actions .btn {
    margin: 0;
    padding: 7px 10px;
    font-size: 11px;
    line-height: 1.4;
    white-space: normal;
    border-radius: 6px;
}

@media (max-width: 576px) {
    .gm-contract-item {
        padding: 12px;
    }

    .gm-contract-item__head>.badge {
        margin-left: 0;
    }

    .gm-contract-item__actions .btn {
        flex: 1 1 auto;
    }
}

/* Contrato firmado manualmente: registro recibido para validación. */
.gm-contract-item__received {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
    padding: 11px;
    border: 1px solid #c9e6dc;
    border-radius: 9px;
    background: #f2faf7;
    text-align: left;
}

.gm-contract-item__received-icon {
    display: grid;
    place-items: center;
    flex: 0 0 36px;
    height: 36px;
    background: #dff2e9;
    color: #16704c;
    border-radius: 9px;
}

.gm-contract-item__received-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    line-height: 1.4;
}

.gm-contract-item__received-body strong {
    color: #1b6047;
    font-size: 12px;
}

.gm-contract-item__received-body span {
    overflow-wrap: anywhere;
    color: #244b3d;
    font-size: 11px;
}

.gm-contract-item__received-body small {
    color: #5e786d;
    font-size: 10px;
    margin-top: 3px;
}

.gm-contract-item__review-label {
    flex-shrink: 0;
    padding: 5px 8px;
    color: #86600a;
    background: #fff5db;
    border: 1px solid #f6e2a4;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 600;
}

@media (max-width: 576px) {
    .gm-contract-item__received {
        flex-wrap: wrap;
    }

    .gm-contract-item__review-label {
        margin-left: 46px;
    }
}

/* Refresco UI - no modifica ninguna operación ni lógica de filtros */
.gm-budget-refresh {
    padding: 12px 14px 26px;
    color: #334155;
}

.gm-budget-refresh .gm-budget-panel {
    border: 1px solid #e2e8f0;
    border-top: 3px solid #001f3f;
    border-radius: 13px;
    box-shadow: 0 7px 24px rgba(15, 23, 42, .045);
    overflow: hidden;
    background: #fff;
}

.gm-budget-refresh .gm-budget-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 20px 22px;
    background: #fff;
    border-bottom: 1px solid #e8edf3;
}

.gm-budget-refresh .gm-budget-top .card-title {
    float: none;
    margin: 0;
    font-size: 19px;
    font-weight: 750;
    letter-spacing: -.4px;
    color: #12243b;
}

.gm-budget-refresh .gm-budget-top .card-tools {
    float: none;
    margin: 0;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.gm-budget-refresh .gm-budget-top .btn {
    border-radius: 7px;
    padding: 8px 12px;
    font-weight: 600;
    margin-right: 0 !important;
}

.gm-budget-refresh .gm-budget-body {
    padding: 20px 22px;
}

.gm-budget-refresh .gm-budget-body>.row:first-child {
    margin: 0 0 16px;
    padding: 18px 10px 4px;
    border: 1px solid #e4ebf3;
    background: #f8fafc;
    border-radius: 11px;
}

.gm-budget-refresh .gm-budget-body>.row:first-child>div {
    margin-bottom: 14px;
}

.gm-budget-refresh .gm-budget-body label {
    display: block;
    margin-bottom: 6px;
    color: #44556b;
    font-size: 12px;
    font-weight: 700;
}

.gm-budget-refresh .gm-budget-body .form-control {
    border-color: #dbe3ed;
    border-radius: 7px;
    min-height: 39px;
    background: #fff;
    box-shadow: none;
}

.gm-budget-refresh .gm-budget-body .form-control:focus {
    border-color: #4670a0;
    box-shadow: 0 0 0 3px rgba(0, 31, 63, .09);
}

.gm-budget-refresh .gm-budget-body>.row:first-child .btn-block {
    margin-top: 24px !important;
    min-height: 39px;
    border-radius: 7px;
    font-weight: 600;
    background: #fff;
}

.gm-budget-refresh .gm-budget-body>.row:first-child .btn-block.active {
    background: #e8f1fa;
    border-color: #a9c5e4;
    color: #173e65;
}

.gm-budget-refresh .nav-tabs {
    border-bottom: 1px solid #e2e8f0;
    gap: 5px;
}

.gm-budget-refresh .nav-tabs .nav-link {
    border: 0;
    border-bottom: 2px solid transparent;
    border-radius: 0;
    color: #64748b;
    padding: 12px 17px;
    cursor: pointer;
    font-weight: 650;
}

.gm-budget-refresh .nav-tabs .nav-link.active {
    color: #001f3f;
    background: transparent;
    border-bottom-color: #001f3f;
}

.gm-budget-refresh .gm-budget-table-wrap {
    margin-top: 15px;
    border: 1px solid #e3e9f1;
    border-radius: 10px;
    overflow-x: auto;
    overscroll-behavior-x: contain;
}

.gm-budget-refresh .gm-budget-table {
    margin-bottom: 0;
    border: 0;
    width: 100%;
    background: white;
}

.gm-budget-refresh .gm-budget-table thead {
    background: #f0f4f8;
}

.gm-budget-refresh .gm-budget-table thead th {
    vertical-align: middle;
    padding: 14px 12px;
    border-color: #e3e9f1;
    border-top: 0;
    color: #43546b;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .55px;
    white-space: nowrap;
}

.gm-budget-refresh .gm-budget-table tbody td {
    vertical-align: top;
    padding: 15px 12px;
    border-color: #edf1f5;
    font-size: 12px;
    line-height: 1.7;
}

.gm-budget-refresh .gm-budget-table tbody tr:hover {
    background: #f9fbfe;
}

.gm-budget-refresh .gm-budget-table tbody td:nth-child(2) {
    min-width: 260px;
    color: #475569;
}

.gm-budget-refresh .gm-budget-table tbody td:nth-child(2) strong {
    color: #23364d;
}

.gm-budget-refresh .gm-budget-table tbody td:last-child {
    min-width: 300px;
}

.gm-budget-refresh .gm-budget-table .btn {
    margin: 3px !important;
    border-radius: 6px;
    font-weight: 600;
    font-size: 11px;
    padding: 7px 9px;
    transition: background .2s, border-color .2s, transform .2s;
}

.gm-budget-refresh .gm-budget-table .btn:hover {
    transform: translateY(-1px);
}

.gm-budget-refresh .gm-budget-table tfoot td {
    background: #f3f6fa;
    border-color: #e3e9f1;
    padding: 13px;
    font-weight: 700;
}

.gm-budget-refresh .gm-contract-list {
    margin-top: 12px;
}

.gm-budget-refresh .gm-contract-item {
    box-shadow: none;
    border-radius: 9px;
    padding: 13px;
}

.gm-budget-refresh .gm-contract-item__actions .gm-contract-cancel {
    background: #fff;
    color: #b42332;
    border: 1px solid #f0b5bd;
}

.gm-budget-refresh .gm-contract-item__actions .gm-contract-cancel:hover {
    background: #b42332;
    color: #fff;
    border-color: #b42332;
}

.gm-cancel-popup {
    border-radius: 14px !important;
}

.gm-cancel-dialog {
    text-align: left;
    font-size: 13px;
    color: #475569;
}

.gm-cancel-dialog__icon {
    display: grid;
    place-items: center;
    width: 44px;
    height: 44px;
    margin: 0 0 12px;
    background: #fff0f1;
    color: #b42332;
    font-size: 20px;
    border-radius: 11px;
}

.gm-cancel-dialog p {
    line-height: 1.6;
}

.gm-cancel-dialog__notice {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    padding: 12px;
    margin: 13px 0 18px;
    border: 1px solid #f1dfc6;
    background: #fff9ef;
    border-radius: 8px;
    line-height: 1.55;
}

.gm-cancel-dialog__notice i {
    margin-top: 3px;
    color: #b26b15;
}

.gm-cancel-dialog label {
    display: block;
    color: #273b52;
    font-weight: 700;
    margin-bottom: 7px;
}

.gm-cancel-dialog label span {
    color: #b42332;
}

.gm-cancel-dialog textarea.swal2-textarea {
    width: 100%;
    margin: 0;
    padding: 10px;
    border-radius: 8px;
    font-size: 13px;
}

.gm-cancel-dialog small {
    display: block;
    margin-top: 6px;
    color: #7b889b;
}

@media(max-width:767px) {
    .gm-budget-refresh {
        padding: 6px;
    }

    .gm-budget-refresh .gm-budget-top {
        padding: 15px;
        flex-wrap: wrap;
    }

    .gm-budget-refresh .gm-budget-body {
        padding: 12px;
    }

    .gm-budget-refresh .gm-budget-body>.row:first-child {
        padding: 14px 8px 0;
    }

    .gm-budget-refresh .gm-budget-table tbody td {
        padding: 11px 8px;
    }
}

@media(prefers-reduced-motion:reduce) {
    .gm-budget-refresh .btn {
        transition: none !important;
        transform: none !important;
    }
}
</style>
